import { Container, Img, Text } from './styles'

interface Props {
  text: string
  imageSrc: string
}

export const Card = ({ imageSrc, text }: Props) => {
  return (
    <Container>
      <Img src={imageSrc} alt="Card Image" />
      <Text>{text}</Text>
    </Container>
  )
}
